import React, { useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView, getCheapestSelectedPackageOptionWithDefault } from 'selectors/offerPage/offerPageSelectors'
import AdditionalGuestsPopup from 'components/Common/AdditionalGuestsPopup/AdditionalGuestsPopup'
import { includedGuestsExceededItems } from 'lib/checkout/cartReservationUtils'
import useVillasPrice from './useVillasPrice'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface Props {
  packageView: OfferPackageOptionView;
  offer: App.Offer;
  rooms: Array<App.Occupants>;
}

function VillasPriceDetails(props: Props) {
  const { packageView, offer, rooms } = props

  const [price, value, discount] = useVillasPrice(packageView)

  const showIncludedGuestsExceeded = useMemo(
    () =>
      !packageView?.package.roomRate?.extraGuestSurcharges.length &&
      includedGuestsExceededItems(rooms || [], packageView?.package, offer),
    [packageView, rooms, offer],
  )

  return <div>
    <PriceRowPrice
      size="L"
      price={price.hotel}
      saleUnit="total"
    />
    {showIncludedGuestsExceeded && (
      <AdditionalGuestsPopup
        description="+ Extra guest surcharge"
        modalContent={packageView.package.roomPolicyDescription}
      />
    )}
    {!!value && <PriceRowValueDiscountWithCaption
      size="L"
      originalValue={value}
      discountPercentage={discount}
    />}
  </div>
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    packageView: getCheapestSelectedPackageOptionWithDefault(appState, state),
    offer: state.offer,
    rooms: state.rooms,
  }
})(VillasPriceDetails)
